import { G, Rect, Svg, Text as SvgText } from "@react-pdf/renderer";
import { formattedColorMaterial } from "../../../components/formatted/FormattedText";
import { roundPercent } from "./weeklyReportModel";

const niceAxisMax = (value) => {
  const max = Math.max(Number(value) || 0, 1);
  if (max <= 10) return Math.ceil(max);
  if (max <= 25) return Math.ceil(max / 5) * 5;
  if (max <= 50) return Math.ceil(max / 10) * 10;
  return Math.ceil(max / 20) * 20;
};

export const MaterialHorizontalBarChart = ({
  slices = [],
  total = 0,
  width = 380,
  maxItems = 16,
  slotCount = 0,
  rowHeight = 14,
  barThickness = 8,
  labelFontSize = 7,
  valueFontSize = 7,
  paddingLeft = 108,
  maxLabelLength = 20,
}) => {
  const items = (slices || [])
    .filter((slice) => slice.count > 0)
    .slice(0, maxItems);
  const paddingRight = 52;
  const paddingTop = 4;
  const paddingBottom = 18;
  const slotRows = Math.max(items.length, slotCount, 1);
  const chartWidth = width - paddingLeft - paddingRight;
  const axisMax = niceAxisMax(
    Math.max(...items.map((item) => item.percent || 0), 1),
  );
  const height = paddingTop + slotRows * rowHeight + paddingBottom;
  const axisTicks = [0, axisMax / 2, axisMax];
  const axisY = paddingTop + slotRows * rowHeight + 2;

  return (
    <Svg width={width} height={height}>
      {axisTicks.map((tick) => {
        const x = paddingLeft + (tick / axisMax) * chartWidth;
        return (
          <G key={`axis-${tick}`}>
            <Rect
              x={x}
              y={paddingTop}
              width={0.5}
              height={slotRows * rowHeight}
              fill="#F0F0F0"
            />
            <SvgText
              x={x}
              y={axisY + 10}
              textAnchor="middle"
              style={{ fontSize: 7, fill: "#686868" }}
            >
              {`${Math.round(tick)}%`}
            </SvgText>
          </G>
        );
      })}
      {items.map((item, index) => {
        const y = paddingTop + index * rowHeight;
        const barWidth = Math.max(
          2,
          (Math.min(axisMax, item.percent || 0) / axisMax) * chartWidth,
        );
        const rawLabel = item.materialLabel || item.material || "";
        const label =
          rawLabel.length > maxLabelLength
            ? `${rawLabel.slice(0, maxLabelLength - 1)}…`
            : rawLabel;
        const percent =
          total > 0 ? roundPercent((item.count * 100) / total) : 0;
        return (
          <G key={item.material}>
            <SvgText
              x={paddingLeft - 8}
              y={y + rowHeight * 0.7}
              textAnchor="end"
              style={{ fontSize: labelFontSize, fill: "#0F265C" }}
            >
              {label}
            </SvgText>
            <Rect
              x={paddingLeft}
              y={y + (rowHeight - barThickness) / 2}
              width={barWidth}
              height={barThickness}
              fill={formattedColorMaterial(item.material) || "#00A7A6"}
            />
            <SvgText
              x={paddingLeft + barWidth + 6}
              y={y + rowHeight * 0.7}
              style={{ fontSize: valueFontSize, fill: "#0F265C" }}
            >
              {`${percent} %`}
            </SvgText>
          </G>
        );
      })}
    </Svg>
  );
};
